
import React, { useEffect, useState } from "react";
import { Spinner, Modal } from "react-bootstrap";
import Select, { components } from "react-select";
import { addDebitNote, editDebitNote, getBillDetailsByUUID, getTermsConditionKeyValue, getOrgKeyValue } from "../../../services";
import axios from "axios";
import Cookies from "universal-cookie";
import { BILL_URL } from "../../../CONSTANTS";
import { toast } from "react-hot-toast";
import Button from "@mui/material/Button";

const LimitedMenuList = (props) => {
    const MAX_ITEMS = 50;
    const children = Array.isArray(props.children) ? props.children.slice(0, MAX_ITEMS) : props.children;
    return (
        <components.MenuList {...props}>
            {children}
            {Array.isArray(props.children) && props.children.length > MAX_ITEMS && (
                <div style={{ padding: "8px 12px", color: "#999", fontSize: "12px", textAlign: "center" }}>
                    Type to search from {props.children.length} bills...
                </div>
            )}
        </components.MenuList>
    );
};

const debitNoteItemTypeEnumOptions = [
    { label: "Material Return", value: "MATERIAL_RETURN" },
    { label: "Material Damage", value: "MATERIAL_DAMAGE" },
    { label: "Rate Difference", value: "RATE_DIFFERENCE" },
    { label: "Others", value: "OTHERS" },
];

const CreateDebitNote = ({ billRecordId, billNo, show, onHide, isEdit, exData }) => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const defaultSelectedBill = {
        label: "Select Bill",
        value: "",
    };
    const [billListOptions, setBillListOptions] = useState([]);
    const [billDetails, setBillDetails] = useState(null);
    const [selectedBill, setSelectedBill] = useState(defaultSelectedBill);
    const [termsOptions, setTermsOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(date1);
    const [note, setNote] = useState("");
    const [dNo, setDNo] = useState("");
    const [remark, setRemark] = useState("");
    const [terms, setTerms] = useState({
        value: "",
        label: "",
    });

    useEffect(() => {
        if (!show) return;
        getAllBills();
        getTerms();
    }, [show]);

    const getTerms = () => {
        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setTermsOptions(options);
                setTerms(options[0]);
            } else {
                toast(res.message);
            }
        }).catch(err => console.error("Error fetching terms:", err));
    };

    const getAllBills = () => {
        const cook = new Cookies().get("loginData1");
        const token = cook !== undefined ? cook.accessToken : "";
        axios.get(BILL_URL() + "getKeyValueList", {
            headers: { "content-type": "application/json", Accept: "application/json", Authorization: token }
        }).then((res) => {
            const response = res.data;
            if (response.errorCode === 0) {
                const arr = (response.responsePacket || []).map((data) => ({
                    value: data.key,
                    label: data.value,
                    billNo: data.value,
                }));
                arr.unshift(defaultSelectedBill);
                setBillListOptions(arr);
            } else {
                toast(response.message);
            }
        }).catch(err => console.error("Error fetching bills:", err));
    };

    useEffect(() => {
        if (billRecordId && billNo && selectedBill.value === "") {
            setSelectedBill({
                value: billRecordId,
                label: "Selected Bill",
                billNo: billNo
            });
        }
    }, [billRecordId, billNo]);

    useEffect(() => {
        if (selectedBill.billNo) {
            getBillDetailsByUUID(selectedBill.value).then((res) => {
                if (res.errorCode === 0) {
                    let ddd = res.responsePacket;
                    if (isEdit && exData) {
                        let bItems = ddd.itemsList || ddd.billItemsList;
                        let dItems = exData.debitNoteItemsList || exData.purchaseOrderItemBeans;
                        if (bItems && dItems) {
                            const updatedItems = bItems.map(bItem => {
                                const match = dItems.find(dItem => dItem.itemUuid === bItem.itemUuid);
                                if (match) {
                                    const typeOption = debitNoteItemTypeEnumOptions.find(opt => opt.value === match.debitNoteItemTypeEnum);
                                    return {
                                        ...bItem,
                                        ...match,
                                        quantity: bItem.quantity,
                                        qty: match.quantity,
                                        debitNoteItemTypeEnum: typeOption
                                    };
                                }
                                return bItem;
                            });
                            ddd.itemsList = updatedItems;
                            ddd.billItemsList = updatedItems;
                        }
                    }
                    setBillDetails(ddd);
                } else {
                    toast(res.message);
                }
            }).catch(err => console.error("Error fetching bill details:", err));
        }
    }, [selectedBill, isEdit, exData]);

    useEffect(() => {
        if (isEdit && exData) {
            // exData.debitNoteIssueDate comes as dd-MM-yyyy from view, convert to yyyy-MM-dd for input[type=date]
            if (exData.debitNoteIssueDate) {
                const parts = exData.debitNoteIssueDate.split("-");
                if (parts.length === 3 && parts[0].length === 2) {
                    setDate(parts[2] + "-" + parts[1] + "-" + parts[0]);
                } else {
                    setDate(exData.debitNoteIssueDate);
                }
            }
            setNote(exData.reference);
            setDNo(exData.debitNoteNoAlt || "");
            setRemark(exData.remark || "");
            if (termsOptions.length > 0) {
                const term = termsOptions.find(t => t.value === exData.debitNoteTermsConditionId);
                if (term) setTerms(term);
            }
        }
    }, [isEdit, exData, termsOptions]);

    const handleQty = (e, i) => {
        const obj = (billDetails.itemsList || billDetails.billItemsList).map((item, idx) => idx === i ? { ...item } : item);
        let qt = Number(e.target.value);
        if (qt > obj[i].quantity) {
            return;
        }
        obj[i].qty = qt;
        setBillDetails({ ...billDetails, itemsList: obj, billItemsList: obj });
    };

    const submitDebitNote = () => {
        setLoading(true);
        let subTotal = 0;
        let netTax = 0;
        let discountRate = 0;

        let rawItems = billDetails.itemsList || billDetails.billItemsList || [];
        // Use a single pass for calculation and formatting
        let processedItems = [];

        for (let i = 0; i < rawItems.length; i++) {
            let item = { ...rawItems[i] }; // Clone item to avoid direct state mutation
            if (item.qty) {
                item.quantity = item.qty;
                if (item.debitNoteItemTypeEnum && typeof item.debitNoteItemTypeEnum === 'object') {
                    item.debitNoteItemTypeEnum = item.debitNoteItemTypeEnum.value;
                }
                item.amount = (Number(item.rate) || 0) * (Number(item.qty) || 0);
                subTotal += item.amount;
                processedItems.push(item);
            }
        }

        if (billDetails.discountTypeEnum === "Amount") {
            if (subTotal > 0) discountRate = (100 * (Number(billDetails.discountValue) || 0)) / subTotal;
        } else if (billDetails.discountTypeEnum === "Percentage") {
            discountRate = Number(billDetails.discountValue) || 0;
        }

        // Second pass for tax calculation after subTotal is finalized
        for (let i = 0; i < processedItems.length; i++) {
            let item = processedItems[i];
            const taxObj = item.taxBean || item.taxes;
            if (taxObj) {
                const taxRate = Number(taxObj.rate) || 0;
                taxObj.amount = item.amount * taxRate * 0.01 * (1 - discountRate * 0.01);
                netTax += taxObj.amount;
            }
        }

        if (processedItems.length === 0) {
            toast("please select at least 1 item");
            setLoading(false);
            return;
        }

        for (let i = 0; i < processedItems.length; i++) {
            if (!processedItems[i].debitNoteItemTypeEnum) {
                toast("Please select a type for item: " + (processedItems[i].itemTitle || (i + 1)));
                setLoading(false);
                return;
            }
        }

        let data = {
            ...exData,
            debitNoteTermsConditionId: terms.value,
            debitNoteTermsConditions: terms.label,

            debitNoteIssueDate: date,
            debitNoteNoAlt: dNo,

            debitsRemaining: subTotal + netTax - subTotal * 0.01 * discountRate,
            isRedeemed: true,
            reference: note,
            remark: remark,

            roundOffId: 1,
            roundOffTitle: "Round off to nearest zero",

            vendorId: billDetails.vendorId,
            vendorUuid: billDetails.vendorId,
            vendorTitle: billDetails.vendorTitle,
            billDate: billDetails.billDate,
            billId: billDetails.recordId,
            billUuid: billDetails.recordId,
            billNo: billDetails.billNo,
            priceListId: billDetails.priceListId,
            priceListTitle: billDetails.priceListTitle,

            subTotalAmount: subTotal,
            totalAmount: subTotal + netTax - subTotal * 0.01 * discountRate,
            totalTaxAmount: netTax,
            purchaseOrderItemBeans: processedItems,
        };

        if (isEdit) {
            data.recordId = exData.recordId;
            data.debitNoteNo = exData.debitNoteNo;
            editDebitNote(exData.recordId, data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        setLoading(false);
                        if (onHide) onHide();
                    } else {
                        setLoading(false);
                        toast(res.message);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    setLoading(false);
                });
        } else {
            addDebitNote(data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        setSelectedBill(defaultSelectedBill);
                        setTerms(termsOptions[0]);
                        setDate(date1);
                        setDNo("");
                        setNote("");
                        setRemark("");
                        setLoading(false);
                        if (onHide) onHide();
                    } else {
                        setLoading(false);
                        toast(res.message);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    setLoading(false);
                });
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Body>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px",
                    }}
                >
                    <span>{isEdit ? "EDIT" : "NEW"} DEBIT</span>
                    <span>{billNo}</span>
                </div>
                <br />

                {!billRecordId && (
                    <>
                        <h5 className="font-weight-bold">Bill (GRN)</h5>
                        <div className="row mb-3">
                            <div className="col-5">
                                <Select
                                    options={billListOptions}
                                    value={selectedBill}
                                    onChange={(e) => setSelectedBill(e)}
                                    placeholder="Search Bill No..."
                                    filterOption={(option, input) => {
                                        if (!input) return true;
                                        return option.label.toLowerCase().includes(input.toLowerCase());
                                    }}
                                    maxMenuHeight={200}
                                    components={{ MenuList: LimitedMenuList }}
                                />
                            </div>
                            <div className="col-7">
                                {selectedBill.value !== "" && (
                                    <div className="d-flex mt-2 align-items-center">
                                        <span>Bill No.: </span>
                                        <span className="ml-2 font-size-16">{selectedBill.billNo}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                    </>
                )}

                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: "100px" }}>TERMS</td>
                            <td style={{ width: "100px" }}>
                                <Select options={termsOptions} isDisabled value={terms} onChange={(e) => setTerms(e)} />
                            </td>
                        </tr>
                        <tr>
                            <td>DATE</td>
                            <td>
                                <input autoComplete="off" type="date" value={date} className="form-control" onChange={(e) => setDate(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td>DEBITNO.</td>
                            <td>
                                <input autoComplete="off" value={dNo} className="form-control" onChange={(e) => setDNo(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td>NOTE</td>
                            <td>
                                <input autoComplete="off" value={note} className="form-control" onChange={(e) => setNote(e.target.value)} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <hr />
                {selectedBill.value !== "" ? (
                    <>
                        <div className="table-responsive">
                            <table className="table table-bordered" style={{ marginBottom: '120px' }}>
                                <thead>
                                    <tr>
                                        <th scope="col">S NO.</th>
                                        <th scope="col">ITEMS</th>
                                        <th scope="col" style={{ width: '90px' }}>QTY</th>
                                        <th scope="col">TYPE</th>
                                        <th scope="col" style={{ width: '110px' }}>BILLED QTY</th>
                                    </tr>
                                </thead>
                                <tbody style={{ color: "#212529" }}>
                                    {billDetails &&
                                        (billDetails.itemsList || billDetails.billItemsList) &&
                                        (billDetails.itemsList || billDetails.billItemsList).length > 0 &&
                                        (billDetails.itemsList || billDetails.billItemsList).map((data, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{data.itemTitle}</td>
                                                <td>
                                                    <input autoComplete="off" className="form-control" value={data.qty ? data.qty : ""} min={0} type="number" onChange={(e) => handleQty(e, i)} />
                                                </td>
                                                <td>
                                                    <Select
                                                        options={debitNoteItemTypeEnumOptions}
                                                        value={data?.debitNoteItemTypeEnum}
                                                        onChange={(e) => {
                                                            const obj = (billDetails.itemsList || billDetails.billItemsList).map((item, idx) => idx === i ? { ...item, debitNoteItemTypeEnum: e } : item);
                                                            setBillDetails({ ...billDetails, itemsList: obj, billItemsList: obj });
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        maxMenuHeight={200}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                </td>
                                                <td className="text-end">
                                                    <input className="bg-white rounded" style={{ width: '80px', padding: '7px 9px', border: '1px solid #ccc' }} value={data.quantity} disabled />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                            <label className="mb-0 me-3" style={{ minWidth: '80px', fontWeight: 'bold' }}>REMARK</label>
                            <input
                                autoComplete="off"
                                value={remark}
                                className="form-control"
                                placeholder="Enter remark..."
                                onChange={(e) => setRemark(e.target.value)}
                            />
                        </div>
                    </>
                ) : null}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="contained" onClick={submitDebitNote} className="d-flex align-item-center" disabled={loading}>
                    {loading ? (
                        <Spinner
                            disabled={loading}
                            className="costomLoader mr-2"
                            animation="border"
                            size="sm"
                        />
                    ) : (
                        isEdit ? " Update" : " Save"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateDebitNote;
